import React from 'react';

type IconProps = { className?: string; size?: number };

const svg = (
  props: IconProps & { children: React.ReactNode; viewBox?: string },
) => {
  const { className, size = 24, children, viewBox = '0 0 24 24' } = props;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
};

export const IconCheck = (p: IconProps) =>
  svg({ ...p, children: <path d="M20 6L9 17l-5-5" /> });

export const IconLock = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </>
    ),
  });

export const IconClock = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    ),
  });

export const IconAlert = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4M12 16h.01" />
      </>
    ),
  });

export const IconFile = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <path d="M14 2v6h6" />
      </>
    ),
  });

export const IconArrowRight = (p: IconProps) =>
  svg({ ...p, children: <path d="M5 12h14M13 6l6 6-6 6" /> });

export const IconArrowLeft = (p: IconProps) =>
  svg({ ...p, children: <path d="M19 12H5M11 18l-6-6 6-6" /> });

export const IconPulse = (p: IconProps) =>
  svg({ ...p, children: <path d="M22 12h-4l-3 9L9 3l-3 9H2" /> });

export const IconUpload = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <path d="M7 10l5-5 5 5M12 5v14" />
      </>
    ),
  });

export const IconSign = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <path d="M12 19l7-7 3 3-7 7-3-3z" />
        <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
        <path d="M2 2l7.586 7.586" />
      </>
    ),
  });

export const IconLink = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" />
        <path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" />
      </>
    ),
  });

export const IconCard = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <path d="M2 10h20" />
      </>
    ),
  });

export const IconMail = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="M22 7l-10 6L2 7" />
      </>
    ),
  });

export const IconPerson = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </>
    ),
  });

export const IconId = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <circle cx="9" cy="12" r="2.5" />
        <path d="M15 10h3M15 14h3" />
      </>
    ),
  });

export const IconClipboard = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <>
        <path d="M9 11l3 3L22 4" />
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
      </>
    ),
  });

export const IconChat = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.6 8.6 0 0 1-3.8-.9L3 21l1.9-5.2A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z" />
    ),
  });

export const IconAttach = (p: IconProps) =>
  svg({
    ...p,
    children: (
      <path d="M21.4 11.05l-9.2 9.2a5 5 0 0 1-7.1-7.1l9.2-9.2a3.3 3.3 0 0 1 4.7 4.7l-9.2 9.2a1.7 1.7 0 0 1-2.4-2.4l8.5-8.5" />
    ),
  });

export const IconCross = (p: IconProps) =>
  svg({ ...p, children: <path d="M18 6L6 18M6 6l12 12" /> });

export const IconCode = (p: IconProps) =>
  svg({ ...p, children: <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" /> });
